import { Component,  OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AuthHttpService } from 'app/security/authorization';
import { UserRepository } from '../user.repository';
import { UserService } from '../user.service';
import { LoginReponse } from '../login-response.model';
import { LocalStorageProvider } from 'app/shared';
import { NotifyService, ToastType } from 'app/notify';
import { PermissionService } from 'app/security/permission';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public pending: boolean = false;
  private storage: LocalStorageProvider = new LocalStorageProvider();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authHttpService: AuthHttpService,
    private userRepository: UserRepository,
    private userService: UserService,
    private notify: NotifyService,
    private translateService: TranslateService,
    private permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.createLoginForm();
  }

  public login({ valid, value }) {
    if (!valid) {
      return;
    }

    this.userRepository
    .login(
      value.email,
      value.password
    )
    .subscribe(
      (success: LoginReponse) => {
        this.clearForm();

        const userId: string = success.getUserId();

        if (userId) {
          this.authHttpService.setToken(success.getToken());
          this.userService.setUserId(userId);
        } else {
          this.authHttpService.removeToken();
          this.userService.clearUser();
        }

        this.redirect();
      },
      () => {
        this.notify.toast(ToastType.ERROR, this.translateService.instant('login.wrong_login_or_password'));
        this.clearForm();
      }
    );
  }

  private clearForm() {
    this.loginForm.get('password').reset();
    this.pending = false;
  }

  private createLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  private redirect() {
    const url = this.permissionService.linkedURL;

    if (url) {
      this.permissionService.linkedURL = '';
      this.router.navigate([url]);

      return;
    }

    this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/user/login/login.component.ts